import { motion } from "motion/react";

export default function AnimateNumber({ children, KEY }: any) {
    return (
        <motion.div key={KEY} variants={{
            show: {
                opacity: 1,
                transition: {
                    ease: "easeOut",
                    duration: 0.3
                }
            },
            hide: {
                opacity: 0
            }
        }} animate={'show'} initial={'hide'}>
            <>{children}</>
        </motion.div>
    )
}